<template>
	<div>
		<div class="row">
			<div class="col-8 mb-4">
				<h1 class="float-left" v-if="isNew && !learningoutcome.id">{{ $t("add-learning-outcome") }}</h1>
				<h1 class="float-left" v-else-if="loaded">
					<template v-if="learningoutcome.code">{{ learningoutcome.code }}: </template>
					{{ learningoutcome.title }}
				</h1>
				<div class="skeleton midnight h16 w-half" v-else></div>
			</div>
			<div class="col-4 mb-4">
				<button
                    v-if="$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')" 
                    class="btn btn-primary float-right ml-4" 
                    @click="finishEditing" 
                    :disabled="!learningoutcome.title"
                >
					{{ $t("save") }}
				</button>
			</div>
		</div>

		<!--div class="row" v-if="success">
			<div class="col-12">
				<b-alert variant="success" show
					>{{ $t("saved") }}
					<router-link to="/curriculum-mapping/learning-outcomes">{{
						$t("back-to-learning-outcomes-groups")
					}}</router-link></b-alert
				>
			</div>
		</div-->

		<div class="row" v-if="error">
			<div class="col-12">
				<b-alert variant="danger" show>{{ error }}</b-alert>
			</div>
		</div>

		<div v-if="loaded">
			<TextInput
				:label="$t('code')"
				v-model="learningoutcome.code"
			/>
			<TextInput
				:label="$t('title')"
				v-model="learningoutcome.title"
			/>
			<TextAreaAutosize
				:label="$t('notes')"
				v-model="learningoutcome.note"
			/>


        	<h2>{{  $t('nodes')}}</h2>
			<NodeSelector
				v-model="learningoutcome.curriculummap"
				:loading="!loaded"
				:availableNodes="nodes"
				:canEdit="$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')"
			/>

			<h2>{{ $t("learning-outcomes") }}</h2>
			<LearningOutcomesMapper
				v-model="learningoutcome.learningoutcomes"
                :viewOnly="!$UserSession.hasPriv.call(this, 'CURRICULUM_MANAGE')"
			/>

		</div>
		<div v-else>
			<div class="skeleton midnight h16 w-half"></div>
			<div class="skeleton midnight h16 w-half"></div>
		</div>

	</div>
</template>

<script>
import NodeSelector from "src/components/CurriculumMapping/NodeSelector.vue";
import LearningOutcomesMapper from "src/components/LearningOutcomes/LearningOutcomesMapper";
import CurriculumMap from 'src/modules/curriculummap.js'
import LearningOutcomes from "src/modules/learningoutcomes.js";

export default {
	components: {
		NodeSelector ,
		LearningOutcomesMapper
	},
	data: function () {
		return {
			error: null,
			loaded: false,
            learningoutcome: {
            	id: null ,
            	code: '' ,
            	title: '' ,
            	note: '' ,
            	learningoutcomes: [] ,
            	curriculummap: []
            },
            nodes: []
		};
	},
	mounted() {
        this.LearningOutcomes = new LearningOutcomes();

        // We call the Curriculum Map class
        this.CurriculumMap = new CurriculumMap();
        this.CurriculumMap.getNodes({path_in_string: true }).then((res) => {

            this.nodes = res
            if(this.$route.params.id) this.getLearningOutcome()

        })
        .finally(() => { this.loaded = true });

	},
	methods: {
        getLearningOutcome() {
            this.LearningOutcomes.get(this.$route.params.id)
            .then((res) => {
                res.curriculummap = this.addPathToNodes(res.curriculummap);
                this.learningoutcome = res;
				
			}).catch(error => {
				this.$log.error.call(this, error);
			});
        },
        addPathToNodes(array){
            // We take an array and add the paths in allNodes obtained from getNodes

            // First, we create a map of the result array objects by id
            const nodesMap = new Map(
                array.map(obj => [obj.id, obj])
            );

            // Then, we add additional keys and filter out objects not shared by both arrays
            array = this.nodes
                .map(obj => {
                    const additionalInfo = nodesMap.get(obj.id);
                    return additionalInfo ? { ...obj, ...additionalInfo } : null;
                })
                .filter(obj => obj !== null);
        
            return array;
        },
		finishEditing () {
            this.$store.commit("showBlockingSpinner");
			this.saveLearningOutcome();
		},
		startEditing() {
			this.editing = true;
		},
        saveLearningOutcome() {
			this.$cfetch(`${this.$settings.APIBaseURL}/learningoutcome/save`, {
				method: "post",
				data: this.learningoutcome
			})
			.then((res) => {
                this.$store.commit("hideBlockingSpinner");
				if (res.status === "SUCCESS") {

					this.error = null;
					//this.success = true;
					this.editing = false;
                    this.loaded = true;

					res.result.curriculummap = this.addPathToNodes(res.result.curriculummap);
                    this.learningoutcome = res.result;

				} else {
					if (res.error_message) {
						this.error = res.error_message;
					} else {
						this.error = "There was a problem saving the learning outcome group.";
					}
				}
			})
			.catch((error) => {
				this.$store.commit("hideBlockingSpinner");
				this.$log.error.call(this, error);
				this.error = "There was a problem saving the learning outcome group.";
			});
        }
	},
	computed: {
		isNew: function () {
			return !this.$route.params["group_id"];
		},
	},
};
</script>


